import { IIconBase } from '..'

const googleIcon = ({
  color = '#4285F4',
  height = 29,
  width = 28,
}: IIconBase) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 28 29'
      fill='none'
    >
      <g clipPath='url(#clip0_6_3624)'>
        <path
          d='M27.727 14.8225C27.727 13.8709 27.6499 12.914 27.4853 11.9778H14.28V17.3689H21.842C21.5283 19.1077 20.52 20.6458 19.0436 21.6232V25.1213H23.5551C26.2044 22.6829 27.727 19.082 27.727 14.8225Z'
          fill={color}
        />
        <path
          d='M14.28 28.501C18.0559 28.501 21.2402 27.2612 23.5602 25.1213L19.0487 21.6232C17.7935 22.4771 16.1731 22.9607 14.2852 22.9607C10.6328 22.9607 7.53596 20.4966 6.42481 17.1837H1.76929V20.7898C4.14592 25.5174 8.98663 28.501 14.28 28.501Z'
          fill='#34A853'
        />
        <path
          d='M6.41966 17.1837C5.83322 15.4449 5.83322 13.5621 6.41966 11.8234V8.21729H1.76928C-0.216388 12.1732 -0.216388 16.8339 1.76928 20.7898L6.41966 17.1837Z'
          fill='#FBBC04'
        />
        <path
          d='M14.28 6.04127C16.276 6.01041 18.2051 6.76146 19.6506 8.14012L23.6477 4.14305C21.1167 1.76642 17.7575 0.45979 14.28 0.500943C8.98663 0.500943 4.14592 3.48459 1.76929 8.21728L6.41966 11.8234C7.52567 8.50536 10.6276 6.04127 14.28 6.04127Z'
          fill='#EA4335'
        />
      </g>
      <defs>
        <clipPath id='clip0_6_3624'>
          <rect
            width='28'
            height='28'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default googleIcon
